import { translate } from '../../../Internationalization';

const headerKeyList = [
	'vendor_name',
	'vendor_category',
	'offer_name',
	'vendor_zip',
	'status',
	'edit',
];

/** @returns {{title: string}[]} */
export default function getVendorsTableHeader() {
	return headerKeyList.map((key) => ({
		title: translate(`agent.pages.offers.view.table.${key}`),
	}));
}
